<script>
export default {};
</script>

<template>
  <div>
    <!--start ABOUT US-->
    <div class="container margin-t-20">
      <h3 align="center"><br>Conoce nuestras asistecias<br></h3>
      <div class="section-title-border margin-t-20"></div>
      <div class="row margin-t-30" style="margin-left: 0px">
        <div class="col-lg-4">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-diamond text-custom"></i>
            <h4 class="padding-t-15">Legal</h4>
            <ul align="justify" class="leg">
              <li>En caso de daño en propiedad ajena o lesiones a tercero</li>
              <li>Asistencia y defensa legal por accidentes automovilísticos</li>
              <li>En caso de calquier tipo de accidente</li>
            </ul>
            <p class="padding-t-15 text-muted" align="center">*Consulta términos, condiciones y coberturas de tu póliza.
            </p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-display2 text-custom"></i>
            <h4 class="padding-t-15">Médica</h4>
            <ul align="justify" class="med">
              <li>Ambulancia aérea debido a una emergencia</li>
              <li>Transportación o repatriación en caso de fallecimiento</li>
              <li>Boleto de viaje redondo y hospedaje para una persona</li>
            </ul>
            <p class="padding-t-15 text-muted" align="center">*Consulta términos, condiciones y coberturas de tu póliza.
            </p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-piggy text-custom"></i>
            <h4 class="padding-t-15">En el camino</h4>
            <ul align="justify" class="cam">
              <li>Si alguna llanta del vehículo Asegurado llegara a poncharse.</li>
              <li>En caso de que el vehículo Asegurado se quedara sin batería.</li>
              <li>Servicio de Grúa y Pago del Servicio</li>
            </ul>
            <p class="padding-t-15 text-muted" align="center">*Consulta términos, condiciones y coberturas de tu póliza.
            </p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="services-box text-center hover-effect">
            <i class="pe-7s-science text-custom"></i>
            <h4 class="padding-t-15">Más servicios</h4>
            <ul align="justify">
              <li>Interrupción de viaje en caso de robo, perdida total o reparación</li>
              <li>Anticipo de efectivo</li>
              <li>Información turística</li>
              <li>Transmisión de mensajes urgentes</li>
            </ul>
            <p class="text-muted" align="center"><br>*Consulta términos, condiciones y coberturas de tu
              póliza.</p>
          </div>
        </div>
        <div class="col-lg-4">
          <img src="../assets/images/pyramid.jpg" alt="..." style="max-width: 100%; padding-top: 150px;" class="pi1">
        </div>
        <div class="col-lg-4" style="margin-right: 185px;">
          <p class="padding-t-15 text-muted3-3" align="center" style="width: 550px;">*Consulta términos, condiciones y
            coberturas
            de tu póliza.</p>
        </div>
        <div class="col-lg-4">
          <img src="../assets/images/pyramid.jpg" alt="..." style="max-width: 100%; padding-top: 150px;">
        </div>
      </div>
    </div><br>
    <section class="section bg-light" id="features">
      <div class="container high">
        <div class="row vertical-content" style="margin-left: 2px;">
          <div class="col-lg-5-hg">
            <div class="features-box">
              <h3 style="padding-left: 11px;">Asistencias Destacadas</h3>
              <div class="section-title-border-hg margin-t-20 margin-l"></div>
              <ul class="text-muted4-4 list-unstyled margin-t-30 features-item-list">
                <li class>Cobertura amplia para Motocicletas (excluyendo Gastos Médicos).</li>
                <li class>Renta de auto hasta por 5 días con $70dlls diarios por avería o accidente.</li>
                <li class>Vandalismo y Robo parcial hasta Valor Comercial.</li>
                <li class>Asistencia Vial sin limite de eventos durante la vigencia de la póliza.</li>
                <li class>No afecta cobertura licencia vencida o de procedencia USA/MEX.</li>
                <li class>Grúa o asistencia en el camino hasta $1,000.00 dlls.</li>
                <li class>Reparación del vehículo en USA/Mexico donde el cliente prefiera.</li>
              </ul>
              <p class="padding-t-15 text-muted4-4 size">*Consulta términos, condiciones y coberturas de tu póliza.</p>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="features-img features-right text-right">
              <img src="@/assets/images/ejemplo-6-2.jpg" alt="macbook image" class="img-fluid" />
            </div>
          </div>
          <a v-scroll-to="'#contact'" class="cont btn btn-custom btn-rounded margin-t-30 waves-effect waves-light">
            Contáctanos
            <i class="mdi mdi-arrow-right"></i>
          </a>
        </div>
      </div>
    </section>
    <!--END ABOUT US-->

    <!--END WEBSITE-DESCRIPTION-->
  </div>
</template>
<style scoped>
.size {
  font-size: 12.4px;
}

.row-ul {
  width: 80%;
}

.text-muted {
  display: none;
}

@media (max-width: 414px) {

  .high {
    padding-left: 35px;
  }

  .cont.btn {
    margin-left: 32.5%
  }

  .leg,
  .med,
  .cam {
    padding-left: 37px;
    padding-right: 21px;
  }

  .text-muted {
    display: block;
  }

  .text-muted3-3,
  .pi1 {
    display: none;
  }

  .container {
    padding-left: 42px
  }
}

@media (max-width: 991px) {
  .text-muted {
    display: block;
  }

  .text-muted3-3,
  .pi1 {
    display: none;
  }

}
</style>